<span [ngClass]="{'custom--link font-weight-normal btn--link btn':isCustomLink}">{{ label }}</span>
